import { FC, useState } from 'react'
import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react'

interface IOptions {
  value: string
  label: string
}

interface SelectProps {
  placeholder?: string
  onChange?: (data: { value: string }) => void
  options: IOptions[]
  label?: string
  interfaceType?: 'action-sheet' | 'popover' | 'alert'
  multiple?: boolean
  value?: string
  labelSuffix?: JSX.Element
  name?: string
}

export const Select: FC<SelectProps> = ({
  placeholder = '',
  onChange,
  label,
  options,
  interfaceType,
  multiple = false,
  labelSuffix,
  value,
  name,
}) => {
  const [fieldValue, setFieldValue] = useState(value || null)

  const handleChange = (value) => {
    setFieldValue(value)
    handleValue(value)
  }

  const handleValue = (value: string) => {
    if (typeof onChange === 'function') {
      const data = {
        value,
      }

      onChange(data)
    }
  }

  return (
    <IonItem>
      {label && (
        <IonLabel>
          {label}
          {labelSuffix}
        </IonLabel>
      )}
      <IonSelect
        interface={interfaceType}
        multiple={multiple}
        placeholder={placeholder}
        onIonChange={(e) => handleChange(e.detail.value)}
        value={fieldValue}
        name={name}
      >
        {options.map(({ value, label }) => (
          <IonSelectOption key={value} value={value}>
            {label}
          </IonSelectOption>
        ))}
      </IonSelect>
    </IonItem>
  )
}
